(function () {
  if (window.__indexEmailSubscribeKlaviyo) return;
  window.__indexEmailSubscribeKlaviyo = true;

  function buttonLabel(el) {
    return ((el.textContent || el.value || '').replace(/\s+/g, ' ')).trim().toLowerCase();
  }

  function isNativeSubmit(el) {
    var label = buttonLabel(el);
    if (label === 'submit' || label === 'go') return true;
    return el.matches('form > button[type="submit"], form > input[type="submit"]');
  }

  function pickCta(buttons) {
    var designed = buttons.filter(function (btn) {
      return !isNativeSubmit(btn);
    });
    return designed[0] || buttons[0];
  }

  function markLayout(root, input, button) {
    var node = input.parentElement;

    while (node && root.contains(node) && node !== root) {
      var kids = Array.prototype.slice.call(node.children);
      var inputKid = kids.find(function (el) {
        return el === input || el.contains(input);
      });
      var buttonKid = kids.find(function (el) {
        return el === button || el.contains(button);
      });

      if (inputKid && buttonKid && inputKid !== buttonKid) {
        node.classList.add('index-email-subscribe__klaviyo-row');
        inputKid.classList.add('index-email-subscribe__klaviyo-field');
        buttonKid.classList.add('index-email-subscribe__klaviyo-action');

        kids.forEach(function (el) {
          if (el !== inputKid && el !== buttonKid) {
            el.classList.add('index-email-subscribe__klaviyo-spacer');
          }
        });
        return;
      }

      node = node.parentElement;
    }
  }

  function enhance(root) {
    if (!root) return;

    var input = root.querySelector('input[type="email"], input[type="text"]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('button, input[type="submit"]'));
    if (!input || !buttons.length) return;

    var cta = pickCta(buttons);
    buttons.forEach(function (btn) {
      if (btn === cta) {
        btn.classList.add('index-email-subscribe__klaviyo-submit');
        btn.classList.remove('index-email-subscribe__klaviyo-submit-hidden');
        if (root.closest('.index-poster') && window.matchMedia('(max-width: 749px)').matches) {
          btn.style.setProperty('background', '#000', 'important');
          btn.style.setProperty('background-color', '#000', 'important');
          btn.style.setProperty('color', '#fff', 'important');
          btn.style.setProperty('border-radius', '999px', 'important');
        }
        return;
      }

      btn.classList.add('index-email-subscribe__klaviyo-submit-hidden');
      btn.classList.remove('index-email-subscribe__klaviyo-submit');
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-hidden', 'true');
    });

    input.classList.add('index-email-subscribe__klaviyo-input');
    if (!root.querySelector('.index-email-subscribe__klaviyo-row')) {
      markLayout(root, input, cta);
    }
  }

  function scan() {
    document.querySelectorAll('[data-index-email-klaviyo]').forEach(enhance);
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
